const authRoutes = {
    AUTHENTICATION_PLATFORM_AUTHORIZE_V01: {
        URL: '/v0.1/authentication/platform/authorize',
        METHOD: 'POST'
    },
}

const paymentPagesRoutes = {
    PAYMENT_PAGES_FETCH: {
        URL: '/v1/payment-pages/fetch',
        METHOD: 'GET'
    },
    PAYMENT_PAGES_FEE_TYPES_FETCH: {
        URL: '/v1/payment-pages/fee-types/fetch',
        METHOD: 'GET'
    },
    CHECKBOX_FEE_TYPES_FETCH: {
        URL: 'v1/payment-pages/check-box-fee-types/fetch',
        METHOD: 'GET'
    },
    PAYMENT_PAGES_FEE_TYPES_CALCULATE: {
        URL: '/v1/payment-pages/fee-types/calculate',
        METHOD: 'POST'
    },
}

const formEditorRoutes = {
    FORM_EDITOR_FORM_FIELDS_UPDATE: {
        URL: '/v1/form-editor/form-fields/update',
        METHOD: 'PATCH'
    },
}

const studentsRoutes = {
    STUDENTS_FETCH: {
        URL: '/v1/students/fetch',
        METHOD: 'GET'
    },
    STUDENTS_FIELD_DETAILS_FETCH: {
        URL: '/v1/students/field-details/fetch',
        METHOD: 'GET'
    },
    STUDENTS_CREATE: {
        URL: '/v1/students/create',
        METHOD: 'POST'
    },
    STUDENTS_WRAPPER_CREATE: {
        URL: '/v1/students/wrapper',
        METHOD: 'POST'
    },
    STUDENTS_RECEIPT_FETCH: {
        URL: '/v1.2/students/application-fee-type/order/fetch',
        METHOD: 'GET'
    },
}

const gileClassRoutes = {
    GILE_CLASSES_FETCH: {
        URL: '/v1/gile',
        METHOD: 'GET'
    },
}

const customerDetailsUpdateMobileRoutes = {
    CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH: {
        URL: '/v1/customer/customer-details/update-mobile',
        METHOD: 'PATCH'
    },
}

export const routes = {
    ...authRoutes,
    ...paymentPagesRoutes,
    ...formEditorRoutes,
    ...studentsRoutes,
    ...gileClassRoutes,
    ...customerDetailsUpdateMobileRoutes,
}